export default __webpack_public_path__ + "static/media/11.c345561b.jpeg";